import { z } from "zod";

export const updateUserSchema = z.object({
  lastName: z.string(),
  firstName: z.string(),
  email: z.string().email({ message: "L'email doit être un email valide" }),
});

export type UserUpdateFormData = z.infer<typeof updateUserSchema>;

export const updatePasswordSchema = z
  .object({
    currentPassword: z.string({ message: "Renseignez votre mot de passe" }),
    newPassword: z.string({ message: "Renseignez votre nouveau mot de passe" }),
    newPasswordConfirmation: z.string({
      message: "Renseignez la confirmation de votre mot de passe",
    }),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirmation, {
    message:
      "Le nouveau mot de passe et sa confirmation doivent être identiques",
    path: ["newPasswordConfirmation"],
  });

export type UpdatePasswordFormData = z.infer<typeof updatePasswordSchema>;
